import styled from 'styled-components';

export const ColorsContainer = styled.div`
  border-radius: 0 4px 4px 0;
  display: flex;
  flex-direction: column;
  height: 52px;
  overflow: hidden;
  width: 10px;

  &:first-child {
    border-radius: 4px 0 0 4px;
  }
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Container = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: 'Nerko One', cursive;
  font-size: 60px;
  font-weight: 400;
  margin-top: 12px;
`;
Container.displayName = 'Container';

export const Logo = styled.img`
  height: 70px;
  position: relative;
  top: -4px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  color: #083370;
  font-size: 54px;
  line-height: 42px;
  margin: 0 12px 0 0;
  min-width: 50px;
  height: 40px;
  text-align: center;
`;
Points.displayName = 'Points';

export const PointsRight = styled(Points)`
  margin: 0 0 0 12px;
`;
PointsRight.displayName = 'PointsRight';

export const TeamName = styled.div`
  letter-spacing: 2px;
  line-height: 56px;
  min-width: 130px;
  padding: 0 16px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const TeamsContainer = styled.div`
  align-items: center;
  background: #083370;
  border-radius: 4px;
  color: #ffffff;
  display: flex;
  height: 56px;
`;
TeamsContainer.displayName = 'TeamsContainer';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: 0 0 4px 4px;
  display: flex;
  height: 44px;
  justify-content: center;
  width: 194px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #083370;
  font-size: 48px;
  font-weight: 400;
  text-align: center;
`;
Timer.displayName = 'Timer';

export const TopContainer = styled.div`
  align-items: center;
  display: flex;
  height: 56px;
`;
TopContainer.displayName = 'TopContainer';
